import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import Select from "react-select";
import { useState, useEffect } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { customSelectStyles } from '../../../utils/reactSelectStyles';
import { useGetUserPreferences } from '../../../hooks/useGetUserPreferences';
import { useUpdateUserPreferences } from '../../../hooks/useUpdateUserPreferences';

const scopeOptions = [
    { value: 'ALL', label: 'Toutes les notifications (même sans assignation)' },
    { value: 'ASSIGNED', label: 'Uniquement mes assignations' },
    { value: 'NONE', label: 'Aucune notification par email' },
];

const NotificationsTab = ({ userId: userIdProp = null, isAdmin = false }) => {
    const { user: currentUser } = useAuth();
    const userId = isAdmin ? userIdProp : currentUser?.data?.id;

    const { data: prefsData, isLoading, isError } = useGetUserPreferences(userId);
    const updateMutation = useUpdateUserPreferences();

    const [ticketScope, setTicketScope] = useState(null);
    const [projectScope, setProjectScope] = useState(null);

    useEffect(() => {
        if (prefsData?.data) {
            setTicketScope(scopeOptions.find(o => o.value === prefsData.data.ticket_scope) ?? scopeOptions[1]);
            setProjectScope(scopeOptions.find(o => o.value === prefsData.data.project_scope) ?? scopeOptions[1]);
        }
    }, [prefsData]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!userId || !ticketScope || !projectScope) return;
        updateMutation.mutate({
            userId,
            preferences: {
                ticket_scope: ticketScope.value,
                project_scope: projectScope.value,
            }
        });
    };

    return (
        <Row className='ml-3'>
            <Col xl={6}>
                <Form onSubmit={handleSubmit}>
                    <Card>
                        <Card.Header className="py-2 d-flex">
                            <Card.Title>
                                <span className='text-body text-s m-0 p-0'>Notifications par email</span>
                            </Card.Title>
                        </Card.Header>
                        <Card.Body className='d-flex flex-column'>
                            <span className='text-muted text-sm mb-4 font-italic'>
                                Choisissez pour quels tickets et projets vous souhaitez recevoir des notifications par email.
                            </span>

                            {isError && (
                                <div className="alert alert-danger py-2 small mb-3">
                                    Impossible de charger les préférences. Veuillez recharger la page.
                                </div>
                            )}

                            <Form.Group controlId='idTicketScope' className='mb-4'>
                                <Form.Label className='text-body text-sm'>Tickets</Form.Label>
                                <Select
                                    options={scopeOptions}
                                    value={ticketScope}
                                    onChange={setTicketScope}
                                    menuPortalTarget={document.body}
                                    styles={{ ...customSelectStyles, menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isLoading={isLoading}
                                    placeholder="Sélectionnez une option"
                                />
                                <Form.Text className="text-muted small fst-italic">
                                    Définit pour quels tickets vous recevez des emails (création, intervention, clôture…).
                                </Form.Text>
                            </Form.Group>

                            <Form.Group controlId='idProjectScope' className='mb-4'>
                                <Form.Label className='text-body text-sm'>Projets</Form.Label>
                                <Select
                                    options={scopeOptions}
                                    value={projectScope}
                                    onChange={setProjectScope}
                                    menuPortalTarget={document.body}
                                    styles={{ ...customSelectStyles, menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isLoading={isLoading}
                                    placeholder="Sélectionnez une option"
                                />
                                <Form.Text className="text-muted small fst-italic">
                                    Définit pour quels projets vous recevez des emails (mises à jour, jalons…).
                                </Form.Text>
                            </Form.Group>

                            <Button
                                variant="primary"
                                type="submit"
                                className="mt-2"
                                disabled={updateMutation.isPending || isLoading}
                            >
                                {updateMutation.isPending ? 'Sauvegarde...' : 'Sauvegarder les préférences'}
                            </Button>
                        </Card.Body>
                    </Card>
                </Form>
            </Col>
        </Row>
    );
};

export default NotificationsTab;
